import { useState } from 'react';
import { useIntegrationMode } from '../../contexts/IntegrationModeContext';

const ConnectionStatusIndicator = () => {
  const { mode, ehrName } = useIntegrationMode();
  const [showTooltip, setShowTooltip] = useState(false);

  const config = {
    enable: {
      dotColor: '#22c55e',
      label: 'Enable Health \u00B7 Live sync',
      labelColor: 'rgba(255,255,255,0.6)',
      tooltip: 'Native integration active \u2014 all patient data, notes, and claims sync in real time.',
    },
    fhir: {
      dotColor: '#22c55e',
      label: 'EHR synced',
      labelColor: 'rgba(255,255,255,0.5)',
      tooltip: `Patient data syncing automatically from ${ehrName || 'your EHR'}.`,
    },
    assist: {
      dotColor: '#6b7280',
      label: 'Assist mode',
      labelColor: 'rgba(255,255,255,0.4)',
      tooltip: 'Using Lens for data capture. Connect your EHR for automatic sync.',
    },
  };

  const c = config[mode] || config.assist;

  return (
    <div
      className="relative flex items-center gap-1.5 cursor-default"
      onMouseEnter={() => setShowTooltip(true)}
      onMouseLeave={() => setShowTooltip(false)}
      data-testid="connection-status-indicator"
    >
      <div
        className="flex-shrink-0"
        style={{ width: 6, height: 6, borderRadius: '50%', background: c.dotColor }}
      />
      <span style={{ fontSize: 11, color: c.labelColor, whiteSpace: 'nowrap', fontWeight: 400 }}>
        {c.label}
      </span>
      {showTooltip && (
        <div
          className="absolute top-full right-0 mt-2 z-50"
          style={{
            background: '#1a1a1a',
            color: 'rgba(255,255,255,0.8)',
            fontSize: 11,
            padding: '6px 10px',
            borderRadius: 6,
            whiteSpace: 'nowrap',
            pointerEvents: 'none',
            border: '0.5px solid rgba(255,255,255,0.1)',
            boxShadow: '0 4px 12px rgba(0,0,0,0.3)',
          }}
          data-testid="connection-status-tooltip"
        >
          {c.tooltip}
        </div>
      )}
    </div>
  );
};

export default ConnectionStatusIndicator;
